import { Box, Typography } from "@mui/material";

export default function NoContentView(props) {
    const { message, withBoarder = true } = props
    return <Box style={{ flexGrow: 2, marginBlock: "0.5em", marginInline: "1em", padding: "0.5em", display: "flex", flexDirection: "row", justifyItems: "center", alignItems: "center", borderRadius: "0.5em", border: withBoarder ? "2px solid grey" : undefined }} >
        <Typography margin="auto" color={"GrayText"} variant={"subtitle2"}>{message}</Typography>
    </Box>
}